import React, { useState, useEffect, useRef, useCallback } from 'react';
import { trackVipPopup } from '../utils/analytics';
import useModalA11y from '../hooks/useModalA11y';
import { useLocation } from 'react-router-dom';
import VipScratch from './VipScratch';
import {
  POPUP_KULCS, POPUP_KESLELTETES_MS, POPUP_GORGETES_ARANY, popupMentesUtvonal, popupSzunetel,
} from '../constants/popupSzabalyok';

const STORAGE_KEY = POPUP_KULCS;

// A süti-hozzájárulás kulcsa (CookieBanner). A popup NEM jelenhet meg, amíg a
// látogató nem döntött: a cookie-sáv fölé kerülne, és a hozzájárulás gombjai
// fizikailag elérhetetlenné válnának. Külső auditon mérve: 35,5 s után két
// `aria-modal="true"` dialógus volt egyszerre nyitva, azonos pozícióban.
const CONSENT_KEY = 'norbiphone_cookie_consent';
// Ha a döntés még nem született meg, ennyinként nézzük újra. Enélkül a popup
// SOHA nem jelenne meg annak, aki 35 s után fogadja el a sütiket.
const CONSENT_POLL_MS = 2000;

/** true, ha a látogató már döntött a sütikről (bármelyik irányba). */
const consentDecided = () => {
  try { return localStorage.getItem(CONSENT_KEY) != null; } catch { return false; }
};

export default function EmailPopup() {
  const [visible, setVisible] = useState(false);
  const dialogRef = useRef(null);
  const { pathname } = useLocation();

  // Oldalanként újraindul: az időzítő és a görgetés MINDIG az aktuális oldalra
  // vonatkozik, így egy navigáció után nem ugrik fel azonnal (a korábbi
  // oldalon „összegyűjtött" 35 s miatt). Tiltott oldalon nem is élesedik.
  useEffect(() => {
    if (visible || popupMentesUtvonal(pathname)) return undefined;
    let tarolt = null;
    try { tarolt = localStorage.getItem(STORAGE_KEY); } catch { /* privát mód */ }
    if (popupSzunetel(tarolt)) return undefined;

    let poll = null;
    let kesz = false;
    const show = (source) => {
      if (kesz) return;
      kesz = true;
      trackVipPopup('open', source);
      setVisible(true);
    };
    // Szándékjel után: ha már van süti-döntés, azonnal; ha nincs, megvárjuk.
    const jelzes = (source) => {
      if (kesz || poll) return;
      if (consentDecided()) return show(source);
      poll = setInterval(() => {
        if (!consentDecided()) return;
        clearInterval(poll); poll = null;
        show(source);
      }, CONSENT_POLL_MS);
    };

    const timer = setTimeout(() => jelzes('timer'), POPUP_KESLELTETES_MS);

    const handleScroll = () => {
      const doc = document.documentElement;
      const max = doc.scrollHeight - window.innerHeight;
      if (max > 0 && window.scrollY / max >= POPUP_GORGETES_ARANY) jelzes('scroll');
    };
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Kilépési szándék: csak egeres (asztali) eszközön értelmes.
    const handleMouseLeave = (e) => {
      if (e.clientY <= 10) jelzes('exit_intent');
    };
    document.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      clearTimeout(timer);
      if (poll) clearInterval(poll);
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [pathname, visible]);

  // Ha nyitott popup mellett tiltott oldalra navigál (pl. a kaparós linkjéről a
  // játékszabályzatra), a popup becsukódik – bezárásként NEM számít.
  useEffect(() => {
    if (visible && popupMentesUtvonal(pathname)) setVisible(false);
  }, [pathname, visible]);

  const dismiss = useCallback(() => {
    trackVipPopup('close');
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ dismissedAt: Date.now() })); } catch { /* privát mód */ }
    setVisible(false);
  }, []);

  useModalA11y(dialogRef, { active: visible, onEscape: dismiss });

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-end sm:items-center justify-center p-4"
      style={{ background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)' }}
      onClick={(e) => { if (e.target === e.currentTarget) dismiss(); }}
    >
      <div
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-label="VIP Klub – kaparós sorsjegy"
        tabIndex={-1}
        className="relative w-full max-w-sm bg-white rounded-2xl shadow-2xl outline-none max-h-[90vh] overflow-y-auto p-6">
        {/* A tartalom a KAPARÓS komponens – ugyanaz, ami a /vip-klub oldalon
            beágyazva fut. A popup csak a keret: megjelenítési logika (30 s /
            50% görgetés / exit-intent, lásd constants/popupSzabalyok.js), consent-kapu és modál-a11y.
            A régi „2 000 Ft kedvezmény” fejléc MEGSZŰNT: a 2 000 Ft mostantól
            hat nyeremény egyike, 12% eséllyel – garantált ígéretként hirdetni
            olyan ígéret lenne, amit az esetek 88%-ában nem tartunk be. */}
        <VipScratch variant="modal" onClose={dismiss} />
      </div>
    </div>
  );
}
